import type { ErrorCopy } from '@shared/errors/catalog';

/**
 * The `error_code` values only this surface meets, in the `ANALYTICS_` namespace.
 * Codes more than one feature meets live in `@shared/errors/catalog.ts`.
 *
 * **Never inline a backend code in JSX.** The code is a log key; what reaches
 * the operator is the sentence, and the `X-Request-ID` is what they quote.
 *
 * Tone is load-bearing here. Every one of these is an upstream failure nobody in
 * this console caused, so all of them are neutral — a danger-styled banner on a
 * peer outage teaches an operator that they broke something.
 *
 * `ANALYTICS_REVENUE_UNAVAILABLE` is the sharpest of the four: the service
 * refuses to substitute a zero for a money figure it could not obtain, and the
 * copy has to keep that promise on the screen. An operator reading `٠` where the
 * number is unknown is worse than a stated failure.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = {
  ANALYTICS_FORBIDDEN: {
    message: 'قراءة لوحة التشغيل تحتاج دور مشغّل في التقارير، ولا يحمله حسابك.',
    tone: 'warning',
  },
  ANALYTICS_REVENUE_UNAVAILABLE: {
    message: 'أرقام الإيراد غير متاحة الآن، ولا تُعرض أرقام تقريبية بدلاً منها. أعد المحاولة بعد قليل.',
    tone: 'neutral',
  },
  ANALYTICS_UPSTREAM_FAILED: {
    message: 'إحدى الخدمات لم تجب. أعد المحاولة بعد قليل.',
    tone: 'neutral',
  },
  ANALYTICS_UPSTREAM_TIMEOUT: {
    message: 'تأخّرت إحدى الخدمات عن الردّ. أعد المحاولة بعد قليل.',
    tone: 'neutral',
  },
  ANALYTICS_RATE_LIMITED: {
    message: 'تحديثات كثيرة في وقت قصير. انتظر قليلاً ثمّ أعد المحاولة.',
    tone: 'warning',
  },
};
